import { Button, Drawer } from "antd";
import { IMinerChangerLogProps } from "./MinerChangerLog.props";
import { useMinerChangerLogControl } from "./useMinerChangerLogControl";
import styles from "./MinerChangerLog.module.scss";
import { ArrowRightOutlined, MinusOutlined } from "@ant-design/icons";
import cn from "classnames";
import MinimizedBox from "./MinimizedBox/MinimizedBox";
import { useIntl } from "react-intl";

export default function MinerChangerLog(props: IMinerChangerLogProps) {
  const { formatMessage } = useIntl();
  const control = useMinerChangerLogControl(props);
  return (
    <>
      <MinimizedBox
        logs={control.logs.length}
        onClick={control.onToggleDrawer}
      />
      <Drawer
        open={control.open}
        title={formatMessage({ id: "miner_log.title" })}
        onClose={control.onToggleDrawer}
        closeIcon={<MinusOutlined rev={undefined} />}
        maskClosable={false}
      >
        <div className={styles.content}>
          <div className={styles.info}>
            {formatMessage({ id: "miner_log.info" })}
          </div>
          {control.logs.map((log, i) => (
            <div className={styles.logWrapper} key={log.id + i}>
              <p className={styles.minerHash}>{log.id}</p>
              <div className={styles.log}>
                <div className={styles.minerWrapper}>
                  <label>{formatMessage({ id: "miner_log.label.prev" })}</label>
                  <p className={cn(styles.minerId, styles.before)}>
                    {log.prev}
                  </p>
                </div>
                <ArrowRightOutlined className={styles.arrow} rev={undefined} />
                <div className={styles.minerWrapper}>
                  <label>{formatMessage({ id: "miner_log.label.new" })}</label>
                  <p className={cn(styles.minerId, styles.after)}>{log.next}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className={styles.btns}>
          <Button onClick={control.onToggleDrawer}>
            {formatMessage({ id: "miner_log.cancel" })}
          </Button>
          <Button onClick={control.onClose} type="primary">
            {formatMessage({ id: "miner_log.clear" })}
          </Button>
        </div>
      </Drawer>
    </>
  );
}
